/**
 * 将数组中对象的属性值转为对象
 * @param {Array} arr - 包含key和value属性的对象数组
 * @param {string} keyField - 用作对象键的属性名，默认为'key'
 * @param {string} valueField - 用作对象值的属性名，默认为'value'
 * @returns {Object} - 转换后的对象
 */
export function arrayToObject(arr, keyField = 'key', valueField = 'value', dealValue = function (value) {return value}) {
  if (!Array.isArray(arr)) {
    console.error('arrayToObject: 参数必须是数组');
    return {};
  }
  
  return arr.reduce((result, item) => {
    if (item && typeof item === 'object' && keyField in item && valueField in item) {
      result[item[keyField]] = dealValue(item[valueField]);
    }
    return result;
  }, {});
}

/**
 * 生成Excel文件并下载
 * @param {Array} data - 要导出的数据数组
 * @param {Object} columns - 列配置，格式：{ key: 'field', title: '显示名称' }
 * @param {string} fileName - 文件名，默认：'export.xlsx'
 */
export function exportToExcel(data, columns, fileName = 'export.xlsx') {
  if (!Array.isArray(data) || data.length === 0) {
    console.error('exportToExcel: 数据必须是非空数组');
    return;
  }

  if (!columns || typeof columns !== 'object') {
    console.error('exportToExcel: 列配置必须是对象');
    return;
  }

  // 将列配置转换为数组
  const columnArray = Object.values(columns);
  
  // 生成表头
  const headers = columnArray.map(col => col.title);
  
  // 生成数据行
  const rows = data.map(row => {
    return columnArray.map(col => {
      const value = row[col.key];
      // 处理特殊字符，确保CSV格式正确
      return typeof value === 'string' ? `"${value.replace(/"/g, '""')}"` : value;
    });
  });

  // 合并表头和数据
  const csvContent = [headers, ...rows]
    .map(row => row.join(','))
    .join('\n');

  // 创建Blob对象
  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  
  // 创建下载链接
  const link = document.createElement('a');
  
  // 检查浏览器支持情况
  if (link.download !== undefined) {
    // 现代浏览器
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}

/**
 * 工具函数集合
 */
export default {
  arrayToObject,
  exportToExcel
};